<template>
  <loading-data-page-container :loading="loading" :loading-error="loadingError" :loading-error-message="loadingErrorMsg" class="schaden--page">

    <v-container v-if="!loading && !loadingError" class="pa-0" fluid>

      <div class="semanticsection-title2 primary--text">Übersicht Einzelschäden</div>

      <div v-if="isVertriebsleiter">
        <select-vmnr @vmnr-change="loadSchaeden"></select-vmnr>
      </div>

      <table-container @excel="exportExcel"
                       @reset-filters="resetSingleFilter">

        <!--- full search ----------------------------------------------------------------------------->
        <v-text-field slot="full-search"
                      v-model="search"
                      label="Nach Schaden suchen"
                      append-icon="search"
                      single-line
                      hide-details
                      clearable />

        <!--- detail filters ----------------------------------------------------------------------------->
        <v-row slot="detail-filters"
                  no-gutters
                  class="detail--filters">
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-select v-model="singleFilters.Deckungszusage"
                      :items="deckungszusageOptions"
                      hide-details
                      label="Deckungszusage"
                      @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-select v-model="singleFilters.erledigt"
                      :items="erledigtOptions"
                      hide-details
                      label="Status"
                      @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model="singleFilters.Vertragsnummer"
                          clearable
                          hide-details
                          label="Vertragsnummer"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model="singleFilters.Kundenname"
                          clearable
                          hide-details
                          label="Kundenname"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model="singleFilters.Schadennummer"
                          clearable
                          hide-details
                          label="Schadennummer"
                          @input="applySingleFilter" />
          </v-col>

          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-select v-model="singleFilters.VertragsTyp"
                      :items="vertragsTypOptions"
                      hide-details
                      label="Leistungsart"
                      @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-select v-model="singleFilters.Kosten.mode"
                      :items="[ {text: '=', value: 0}, {text: '<', value: -1}, {text: '>', value: 1} ]"
                      hide-details
                      label="Bisherige Leistungen"
                      @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model="singleFilters.Kosten.value"
                          clearable
                          hide-details
                          label="Betrag bisherige Leistungen"
                          suffix="€"
                          class="anz--schaeden"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="0"
                 md="4" />
          <v-col cols="12"
                 sm="6"
                 md="4">
            <date-field v-model="singleFilters.Meldedatum.von"
                        v-validate="'date_format:DD.MM.YYYY'"
                        :clear-icon-cb="applySingleFilter"
                        hide-details
                        clearable
                        label="Meldedatum von"
                        class="mb0 date--field"
                        @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <date-field v-model="singleFilters.Meldedatum.bis"
                        v-validate="'date_format:DD.MM.YYYY'"
                        :clear-icon-cb="applySingleFilter"
                        hide-details
                        clearable
                        label="Meldedatum bis"
                        class="date--field"
                        @input="applySingleFilter" />
          </v-col>
        </v-row>

        <schaeden-table ref="schadenTable"
                        :schaeden="filteredSchaeden"
                        :search="search"
                        @excel="exportExcel"
                        @show-contract="showContract"
                        @show-damages="showDamages" />

      </table-container>

    </v-container>

  </loading-data-page-container>
</template>
<script>
import httpService from '@/helper/httpService';
import TableContainer from "@/components/kundenverwaltung/TableContainer";
import DateField from "@/components/DateField";
import SchaedenTable from "@/components/kundenverwaltung/SchaedenTable";
import ExcelMixin from '@/pages/kundenverwaltung/ExcelMixin';
import TableDataMixin from '@/pages/kundenverwaltung/TableDataMixin';
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";
import SelectVmnr from "@/components/kundenverwaltung/SelectVmnr";
import dummyData from '@/store/dummyData/schaedenDummyData';

import {DECKUNGSZUSAGE_VALUES, ERLEDIGT_VALUES, LEISTUNGSART_VALUES} from "@/components/kundenverwaltung/valueLists";
import { CONNECTION_ERROR_MESSAGE } from "@/helper/httpService";
import {keyMapLeistungsart} from '@/helper/leistungsart';
import { RIGHTS } from '../../store/user';
import ValidationMixin from '../../components/helper/ValidationMixin';

export default {
  components: {
    LoadingDataPageContainer, SchaedenTable, TableContainer, DateField, SelectVmnr
  },
  mixins: [ExcelMixin, TableDataMixin, ValidationMixin],
  data() {
    return {
      loading: true,
      loadingError: false,
      loadingErrorMsg: '',
      schaeden: null,
      formattedSchaeden: [],
      filteredSchaeden: [],
      singleFilters: this.getInitalFilterState(),
      search: '',
      vertriebsleiterVmnr: ''
    };
  },
  computed: {
    erledigtOptions: function () {
      const options = ERLEDIGT_VALUES.filter(erledigt => {
        return this.schaeden.find(item => item.damage.erledigt.toLowerCase() === erledigt.value);
      });
      options.push({ text: 'alle', value: '' });
      return options;
    },
    deckungszusageOptions: function () {
      const options = DECKUNGSZUSAGE_VALUES.filter((deckungszusage) => {
        return this.schaeden.find(item => item.damage.Deckungszusage === deckungszusage);
      });
      options.push({ text: 'alle', value: '' });
      return options;
    },
    vertragsTypOptions: function () {
      const options = LEISTUNGSART_VALUES.filter((vertragsTyp) => {
        return this.formattedSchaeden.find(item => item.VertragsTyp && item.VertragsTyp.toLowerCase() === vertragsTyp.value);
      });
      options.push({ text: 'alle', value: '' });
      return options;
    },
    isVertriebsleiter: function () {
      return this.$store.getters.checkAuthorization(RIGHTS.VERTRIEBSLEITER);
    }
  },
  created() {
    this.loadSchaeden(null);
  },
  methods: {
    loadSchaeden(vmnr) {
      if (vmnr) this.vertriebsleiterVmnr = vmnr;
      httpService.getSchaedenForUser(vmnr)
        .then(schaeden => {
          this.schaeden = schaeden;
          this.formattedSchaeden = schaeden.map(this.formatData);
          this.filteredSchaeden = [].concat(this.formattedSchaeden);
          this.loading = false;
        })
        .catch(err => {
          console.log(`GET DAMAGES failed with ${err.status}: ${err.message}`);
          //TODO delete dummy data for production
          if (this.$store.state.env.environment === 'development' && err.status !== 403) {
            this.schaeden = dummyData;
            this.formattedSchaeden = dummyData.map(this.formatData);
            this.filteredSchaeden = [].concat(this.formattedSchaeden);
            this.loading = false;
          } else {
            this.loadingErrorMsg = err.status < 500 ? 'Keine Schäden gefunden' : CONNECTION_ERROR_MESSAGE;
            this.loadingError = true;
            this.loading = false;
          }
        });
    },
    formatData(schaden) {
      return {
        Vertragsnummer: schaden.damage.Vertragsnummer,
        Kundenname: `${schaden.contract.Vorname} ${schaden.contract.Name}`,
        Schadennummer: schaden.damage.Schadennummer,
        Deckungszusage: schaden.damage.Deckungszusage,
        Kosten: schaden.damage.Kosten,
        erledigt: schaden.damage.erledigt,
        Meldedatum: this.$helpers.dateToTime(schaden.damage.Meldedatum),
        VertragsTyp: keyMapLeistungsart(schaden.damage.VertragsTyp),
      };
    },
    exportExcel () {
      this.generateExcel(this.schaeden.map(this.formatSchadenDataForExcel), this.columnFormatSchadenDataForExcel(), "Schaeden");
    },
    showContract(vertragsnummer) {
      let route = {
        name: this.vertriebsleiterVmnr ? 'VLBestandDetailPage' : 'BestandDetailPage',
        params: {
          vertragsnummer: vertragsnummer,
          vmnr: this.vertriebsleiterVmnr,
          backTo: 'Schaden'
        }
      };
      let routeData = this.$router.resolve(route);
      window.open(routeData.href, '_blank');
    },
    showDamages(vertragsnummer, newPage) {
      const target = {
        name: this.vertriebsleiterVmnr ? 'VLSchadenDetailPage' : 'SchadenDetailPage',
        params: {
          vertragsnummer,
          vmnr: this.vertriebsleiterVmnr,
          backTo: 'Schaden'
        }
      };
      if (newPage === true) {
        const routeData = this.$router.resolve(target);
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push(target);
      }
    },
    getInitalFilterState() {
      return {
        'Vertragsnummer': '',
        'Kundenname': '',
        'Schadennummer': '',
        'Deckungszusage': '',
        'Kosten': {
          mode: 0,
          value: ''
        },
        'erledigt': '',
        'Meldedatum': {
          von: '',
          bis: ''
        },
        'VertragsTyp': ''
      };
    },
    applySingleFilter() {
      this.filteredSchaeden = this.formattedSchaeden.filter(row => {
        if (this.singleFilters.Kosten.value !== ''
          && !this.filterCompare(row.Kosten, this.formatDecimal(this.singleFilters.Kosten.value), this.singleFilters.Kosten.mode
          )) {
          return false;
        }
        if ((this.singleFilters.Meldedatum.von || this.singleFilters.Meldedatum.bis)
          && !this.filterDateBetween(row.Meldedatum, this.singleFilters.Meldedatum.von, this.singleFilters.Meldedatum.bis)) {
          return false;
        }
        //apply standard filter for remaining header line filters
        const vals = ['Vertragsnummer', 'Kundenname', 'Schadennummer', 'Deckungszusage', 'erledigt', 'VertragsTyp'];
        for (let i = 0; i < vals.length; i++) {
          const columnName = vals[i];
          if (this.singleFilters[columnName] && !this.filterDefault(row[columnName], this.singleFilters[columnName])) {
            return false;
          }
        }
        return true;
      });
    },
    resetSingleFilter() {
      this.singleFilters = this.getInitalFilterState();
      this.applySingleFilter();
    }
  }
};
</script>
<style>
.schaden--page .v-input:not(.v-input--selection-controls) {
  max-width: 344px;
}

.schaden--page .detail--filters div[class*=col-] {
  display: flex;
  justify-content: center;
  padding: 0 20px;
}
</style>
